import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/layouts/default/index.vue").then(m => m.default || m))
}